import { getExtFromFileName, getFileTypeFromExtension } from './fileProcessing';

export async function downloadFileRawDataAsync(fileName: string, file: File) {
  const fileExt = getExtFromFileName(fileName);
  const fileType = getFileTypeFromExtension(fileExt);
  if (!fileType) return;

  const url = window.URL.createObjectURL(new Blob([file], { type: fileType }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
